import {
  DEV_BASE_URL,
  DEV_WPSIGNUP_URL,
  PROD_BASE_URL,
  PROD_WPSIGNUP_URL,
  QA_BASE_URL,
  QA_WPSIGNUP_URL,
  STAGE_BASE_URL,
  STAGE_WPSIGNUP_URL
} from "./constants/appConstants";

export const generateReferralUrls = (code) => {
  let baseSignupUrl = "";
  let baseWpSignupUrl = "";

  if (process.env.REACT_APP_ENV === "dev") {
    baseSignupUrl = DEV_BASE_URL;
    baseWpSignupUrl = DEV_WPSIGNUP_URL;
  } else if (process.env.REACT_APP_ENV === "qa") {
    baseSignupUrl = QA_BASE_URL;
    baseWpSignupUrl = QA_WPSIGNUP_URL;
  } else if (process.env.REACT_APP_ENV === "staging") {
    baseSignupUrl = STAGE_BASE_URL;
    baseWpSignupUrl = STAGE_WPSIGNUP_URL;
  } else if (process.env.REACT_APP_ENV === "prod") {
    baseSignupUrl = PROD_BASE_URL;
    baseWpSignupUrl = PROD_WPSIGNUP_URL;
  }

  return {
    signupPageUrl: code ? `${baseSignupUrl}/${code}` : "",
    wpSignupPageUrl: code ? `${baseWpSignupUrl}/${code}` : ""
  };
};
